<template>
  <div class="waiver-container">
    <div class="waiver-text">
      <p>
        From time to time, The Union of Orthodox Jewish Congregations of America, Yachad,
        NCSY, and its affiliates, employees and agents (together, the “Orthodox Union”)
        take photographs and videos of individuals, including minors, who attend Orthodox
        Union events, programs, and other offerings. The Orthodox Union engages in these
        activities for purposes relating to the advancement of the religious, spiritual,
        charitable, and educational goals and objectives of the Orthodox Union, including
        but not limited to the sharing of photos/videos in newsletters, on our blogs, and
        on our website and social media pages for the purpose of keeping our members and
        others informed of the Orthodox Union’s events and other activities. Please
        complete this form to give us permission to take photos/videos of you and/or your
        children when you participate in Orthodox Union events and to use those
        photos/videos in our printed and online publicity:
      </p>
      <ol>
        <li>
          I hereby authorize the Orthodox Union to take photographs and/or video of me (or
          my children) when I (or my children) participate at Orthodox Union events. I
          grant the Orthodox Union full rights to use and share the images resulting from
          the photographs and/or videos and any reproductions thereof (the “Recording”),
          in whole or in part, along with my (or my children’s) name, biographical
          information and quotations for any purpose including fundraising, publicity,
          advertising, or on social media, all without further obligation or
          compensation.&nbsp; I hereby waive any right of review or approval regarding the
          Recording and the Orthodox Union shall have the right to edit or delete the
          Recording in its sole discretion. I understand that all rights in and to the
          Recording shall be the Orthodox Union’s sole and absolute property. I understand
          that if I access the Orthodox Union’s services through a third party platform,
          product, service, or application (a “Third Party Service”), content and related
          information generated while accessing OU’s services in this manner may be
          monitored, captured, and or recorded by the third parties that provide such
          Third Party Services. I consent to the use and sharing of personal information
          by any such third party as described in the privacy policy available through the
          Third Party Service. I release and forever discharge the Orthodox Union from all
          causes of action, suits, or liability of any kind arising from or in connection
          with the use or publication of any Recording of me or my children made in
          connection with my participation in Orthodox Union events. I waive any right of
          privacy associated with the Recording and I waive any right to compensation
          related to the use of the Recording.
        </li>
        <li>
          I HAVE READ THIS AGREEMENT AND AM FULLY AWARE OF ITS CONTENTS, INCLUDING THE
          RELEASE THAT I HAVE AGREED TO HEREIN.
        </li>
        <li>
          I warrant that I am at least eighteen years of age (or, if not, that my parent
          or legal guardian has agreed to the foregoing and signed below) and that I have
          the full and unrestricted authority to enter into a contract for myself (or, if
          not, that my parent or legal guardian has agreed to the foregoing and signed
          below).
        </li>
        <li>
          If any provision of this agreement is held to be unenforceable, the remainder of
          it shall continue to be in full force and effect.
        </li>
        <li>
          This waiver shall remain in effect until such time as I advise the OU otherwise
          in writing.
        </li>
      </ol>
    </div>
    <div class="waiver-fields">
      <FormRow>
        <label
          ><input
            type="checkbox"
            @value="getValue('custom.mediaRelease')"
            @change="setValue('custom.mediaRelease', $event.target.checked)"
          />
          I accept the terms of the media release</label
        >
      </FormRow>
      <ErrorLabel
        field="custom.mediaRelease"
        customError="Please accept the media release"
      />
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { getValue, setValue } = usePaymentForm();

    return {
      getValue,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
.waiver-text {
  max-height: 200px;
  overflow: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 20px;
}
p,
ul,
ol,
h2 {
  margin-bottom: 20px;
  line-height: 1.5;
  font-size: 14px;
}
li {
  margin-bottom: 5px;
}
label {
  font-size: 14px;
  min-width: 150px;
  color: #222;
}
::v-deep .error-label {
  position: relative;
}
</style>
